import { toast } from "react-toastify";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import {
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";

import ApiService from "../../helpers/Services.js";
import "./dataTable.scss";

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarFilterButton />
      <GridToolbarQuickFilter />
    </GridToolbarContainer>
  );
}

const DataTable = (props) => {
  const deactivateHandler = async (email) => {
    try {
      await ApiService.post("user-management", {
        action: "deactivateUser",
        payload: {
          vendor: "MT",
          email: email,
        },
      });

      props?.fetchUsers();

      toast.success("User deactivated", {
        position: "top-right",
      });
    } catch (error) {
      toast.error(error.message);
      console.error(error);
    }
  };

  const activateHandler = async (email) => {
    try {
      await ApiService.post("user-management", {
        action: "activateUser",
        payload: { vendor: "MT", email: email },
      });
      props?.fetchUsers();

      toast.success("User Activated", {
        position: "top-right",
      });
    } catch (error) {
      toast.error(error.message);
      console.error(error);
    }
  };

  const actionColumn = {
    field: "action",
    headerName: "Action",
    headerClassName: "bg-tb-header h-24",
    // width: 200,
    headerAlign: "center",
    flex: 1,
    renderHeader: (params) => (
      <p className="text-table-header email-container m-0 p-0 font-18-400-24">
        {"Action"}
      </p>
    ),
    renderCell: (params) => {
      const isActive = params.row.status === "Active";

      return (
        <div className="action">
          {isActive ? (
            <button
              className="w-98 bg-activate"
              onClick={() => deactivateHandler(params.row.userid)}
            >
              Deactivate
            </button>
          ) : (
            <button
              className="w-98 bg-activate"
              onClick={() => activateHandler(params.row.userid)}
            >
              Activate
            </button>
          )}
        </div>
      );
    },
  };

  const handleSelectionChange = (newSelectionModel) => {
    // Get the full details of the selected rows
    const selectedRows = props.rows.filter((row) =>
      newSelectionModel.includes(row.id)
    );
    console.log("Selected user details:", selectedRows);
  };

  const shouldShowActionColumn = props?.hideActionColumn;

  const columns = shouldShowActionColumn
    ? [...props.columns]
    : [...props.columns, actionColumn];

  return (
    <div className="dataTable">
      <DataGrid
        className="dataGrid"
        rows={props.rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        density="comfortable"
        pageSizeOptions={[10]}
        // checkboxSelection
        disableRowSelectionOnClick
        // disableColumnFilter
        disableDensitySelector
        disableColumnSelector
        onRowSelectionModelChange={handleSelectionChange}
        sx={{
          // [`& .${gridClasses.row}`]: {
          //   bgcolor: (theme) =>
          //     theme.palette.mode === "light" ? "red" : "blue",
          // },

          [`& .${gridClasses.cell}`]: {
            border: "none",
          },
          // [`& .${gridClasses.ce}`]: {
          //   border: "1px solid black",
          // },
        }}
        rowHeight={40}
        getRowClassName={(params) => {
          return params.id % 2 === 0
            ? "bg-row-even text-table font-16-21-400"
            : "bg-row-odd text-table font-16-21-400";
        }}
        columnHeaderHeight={30}
        onPageChange={(modal) => console.log({ modal })}
      />
    </div>
  );
};

export default DataTable;
